import styled from 'styled-components'

export const ModalAlert = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`

export const Message = styled.div`
  margin-top: 15px;
  font-size: 19px;
  text-align: center;
  color: ${({ theme }) => theme.cor41}!important;
`
